export enum TestResultType {
    Text = 1,
    List = 2,
    Numeric = 3,
    Culture = 4,
    TextReport = 5,
    Image = 6
}
